module.exports = __webpack_public_path__ + "static/media/revenues.f9182c5a.svg";